/**
 * All nudge type names and values
 */
export const NudgeTypes = {
  ALERT_FLOATING: 'ALERT_FLOATING',
  ALERT_GLOBAL: 'ALERT_GLOBAL',
  ALERT_INLINE: 'ALERT_INLINE',
  COACHING_TIP_PULSER: 'COACHING_TIP_PULSER',
  COACHING_TIP_TOOLTIP: 'COACHING_TIP_TOOLTIP',
  MODAL: 'MODAL',
  ONBOARDING_DEMO: 'ONBOARDING_DEMO',
  ONBOARDING_TOUR: 'ONBOARDING_TOUR',
  POPOVER: 'POPOVER',
  POPUP_CSAT: 'POPUP_CSAT',
  POPUP_GROWTH_PROMPT: 'POPUP_GROWTH_PROMPT',
  POPUP_NOTIFICATIONS: 'POPUP_NOTIFICATIONS',
  SIDEBAR_NOTIFICATIONS: 'SIDEBAR_NOTIFICATIONS',
  SIDEBAR_ONBOARDING_TASK_LIST: 'SIDEBAR_ONBOARDING_TASK_LIST',
  POPUP: 'POPUP',
  CALLOUT: 'CALLOUT'
};

/**
 * All nudge event action types
 */
export const NudgeEventTypes = {
  ACTION_TAKEN: 'ACTION_TAKEN',
  RENDERED: 'RENDERED',
  DISMISSED: 'DISMISSED',
  SEEN: 'SEEN'
};